export default __webpack_public_path__ + "static/axieking@2x-e9614a954221ea94223dd6c751f7d243.jpg";